const mediaItems = [
  {
    title: '本周热门电影推荐',
    desc: '精选本周最受关注的热门影片，从院线大片到网络首发，一网打尽。',
    duration: '05:32',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20recommendation%20thumbnail%20with%20film%20poster%20collage%2C%20warm%20theater%20lighting%2C%20golden%20spotlight%20effects%2C%20professional%20video%20thumbnail%20style%2C%20play%20button%20overlay%2C%20entertainment%20content%20creator%20aesthetic&width=700&height=420&seq=media-01-recommend&orientation=landscape',
    alt: '91影视看片下载 - 本周热门电影推荐',
  },
  {
    title: '追剧指南：不可错过的五部国产良心剧',
    desc: '2026年上半年口碑最好的国产剧集盘点，每部都值得二刷。',
    duration: '08:15',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20recommendation%20video%20thumbnail%2C%20elegant%20traditional%20and%20modern%20Chinese%20visual%20mix%2C%20warm%20cinematic%20lighting%2C%20drama%20review%20content%20style%2C%20professional%20media%20thumbnail%20design&width=700&height=420&seq=media-02-guide&orientation=landscape',
    alt: '91影视看片下载 - 追剧指南',
  },
  {
    title: '天美麻花星空影视独家内容预览',
    desc: '天美麻花星空影视免费观看专区最新上线内容抢先看，精彩不容错过。',
    duration: '06:48',
    img: 'https://readdy.ai/api/search-image?query=Premium%20exclusive%20content%20preview%20video%20thumbnail%20with%20golden%20stars%20and%20sparkles%2C%20VIP%20cinema%20theme%2C%20luxurious%20dark%20and%20gold%20aesthetic%2C%20professional%20media%20production%20style%2C%20exclusive%20content%20badge&width=700&height=420&seq=media-03-tianmei&orientation=landscape',
    alt: '天美麻花星空影视免费观看 - 独家内容预览',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            影视推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精选影视内容推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            最新影视推荐与独家内容预览，帮您发现下一个想看的影片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    (el.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl w-6 h-6 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}